import type { FC } from 'react';

import { ComponentsHead } from '@/components/head';
import { AddOnsTemplate } from '@/components/add-ons/template';
import { LinkWithTitle } from '@/components/links';
import { AnchorWithTitle } from '@/components/links/anchor';
import { h3, h4 } from '@/styles/components/titles.module.scss';

export const CHRISTMAS_BOAT_PARADE_TITLE =
  'Christmas Boat Parade';

export const Head = () => {
  return (
    <ComponentsHead
      title="Private Christmas Boat Cruises | Tampa Bay Holiday Charter"
      description="Trade snow for sunsets on a Christmas boat cruise in Tampa Bay. Private charters with lights, music, and warm holiday vibes."
      keywords="Christmas Cruise, Holiday Charter, Tampa Bay, Light Tour"
    />
  );
};

const SpecialEventsChristmasBoatParade: FC = () => {
  return (
    <AddOnsTemplate
      subtitle="Christmas Boat Charters in Tampa Bay – Sunset, Lights & Cheer"
      title="Christmas Boat Charters in Tampa Bay – Sunset, Lights & Cheer" // image={
    >
      <h3 className={h3}>Celebrate the Holidays with Style</h3>
      <p>
        Celebrate the holiday season in style with our
        Christmas Boat Parade Charter.{' '}
        <AnchorWithTitle href="https://www.tampa.gov/events/holiday-lighted-boat-parade/159656">
          Tampa’s Holiday Light Boat Parade
        </AnchorWithTitle>{' '}
        is the city's largest illuminated maritime event,
        where beautifully decorated boats glide along the{' '}
        <LinkWithTitle to="/destinations/">
          Hillsborough River
        </LinkWithTitle>
        , creating a magical holiday display that lights up
        the downtown waterfront.
      </p>
      <p>
        Our{' '}
        <LinkWithTitle to="/services/4-hour-private-party-boat-charter/">
          4-hour private charters
        </LinkWithTitle>{' '}
        depart from the Davis Island Boat Ramp, giving you
        and your guests a front-row seat to this special
        festive event. As you cruise past{' '}
        <LinkWithTitle to="/areas/">
          Curtis Hixon Park, the Armature Works, and through
          downtown Tampa
        </LinkWithTitle>
        , you’ll witness boats covered in lights, holiday
        music drifting through the air, and the festive
        atmosphere of a city in celebration.
      </p>
      <h4 className={h4}>Celebrate in Style this Holiday Season</h4>
      <p>
        We can offer this magical festive cruise for up to
        12 guests on our TBBA Adventure I boat, while the
        Paradiso can accommodate up to 30 guests for larger
        groups.{' '}
        <LinkWithTitle to="/our-boat/">
          Both vessels
        </LinkWithTitle>{' '}
        come packed with the comforts you need to celebrate
        in style – from comfortable seating, Bluetooth music
        options, coolers and other optional add ons such as
        charcuterie boards or seasonal decor.
      </p>
      <p>
        Due to the event’s popularity, we recommend booking
        at least a month in advance. Make this Christmas one
        to remember with a peaceful and picturesque cruise
        through Tampa’s holiday wonderland.
      </p>
    </AddOnsTemplate>
  );
};

export default SpecialEventsChristmasBoatParade;
